import {  
  GET_WASTED_MENU_DATA,
  LOAD_MORE_WASTED_MENU_DATA
} from '../actions/types';

const wastedmenu_data = {
  menuitems: [],
  data: [],
  origData:[],
  dataCount:0,
  dataNext:null,
  dataPrevious:null,
  editModalOpen: false,
  previewModalOpen: false,
  item:[],
  currentProps:null,


};





// eslint-disable-next-line import/no-anonymous-default-export
export default (state = wastedmenu_data, action) => {
  var dataArray;
  switch (action.type) {   


    case GET_WASTED_MENU_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        origData:newdata,
        data: newdata,
        dataCount:newdata.length,
        lastVisible:lastVisible,
        currentProps:action.payload.currentProps
      };

    case LOAD_MORE_WASTED_MENU_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        ...state,
        origData:newdata.concat(state.origData),
        data: newdata.concat(state.data),
        dataCount:newdata.concat(state.origData).length,
        lastVisible:lastVisible,
     
      };
   
    default:
      return state;
  }
};
